export enum ModuleIds {
  Employee = 1,
  Attendance = 2,
  Leave = 3,
  Payroll = 4,
  Vacation = 5,
  Currency = 6,
  ManualJournal = 7,
  ChartAccount = 8,
  Holiday = 9,
  Designation = 10,
  Departments = 11,
  Branch = 12,
  Expenses = 13,
  Banking = 14,
  Accommodation = 15,
  PettyCash = 16,
  TaskManagement = 17,
  ServiceManagement = 18,
  Leads = 19,
  Customers = 20,
  Quotation = 21,
  Invoice = 22,
  SalesOrder = 23,
  Project = 24,
  OrderFlow = 25,
  Refund = 26,
  PaymentReceived = 27,
  PaymentMade = 28,
  Vendor = 29,
  VendorInvoice = 30,
  PurchaseOrder = 31,
  StationaryItems = 32,
  StationaryLog = 33,
  DailyPurchase = 34,
  Suppliers = 35,
  Reports = 36,
  NotificationTemplate = 37,
}

// export enum EmployeePermissionIds {
//   Create = 1,
//   Edit = 2,
//   Delete = 3,
//   List = 4,
// }
